import { config as configureZod, z } from "zod";

configureZod({ jitless: true });

export { z };
